<template>
  <div class="programs-card">
    <br />
    <div class="container px-5 mx-auto">
      <div class="row">
        <br />
      </div>
      <div class="row d-flex justify-content-between">
        <div class="box box1">
          <img src="@/assets/images/ct.png" />
          <br />
          <br />
          <h3 class="pb-3 dark-text">Coding Games</h3>
          <p class="sm-text">
            Video game that incorporates elements of computer programming, Build in your domain specific language
          </p>
          <a class="sm-text bottom text-link blue-bg"
            ><span>Proceed to Game Center</span
            ><span><i class="fas fa-chevron-right"></i></span
          ></a>
        </div>
        <div class="box box2">
          <img src="@/assets/images/cap.png" />
          <br />
          <br />
          <h3 class="pb-3">Forum - Daily Discussions</h3>
          <p class="sm-text">
            Join others in the forum to build awesome stuffs.
          </p>
          <a class="sm-text bottom text-link trans-bg"
            ><span>Proceed to Forum</span
            ><span><i class="fas fa-chevron-right"></i></span
          ></a>
        </div>
        <div class="box box3">
          <img src="@/assets/images/ep.png" />
          <br />
          <br />
          <h3 class="pb-3">Programming Guides & Materials </h3>
          <p class="sm-text">
            Empowering youths across Africa to be leaders and innovators through study materials on emerging technologies
          </p>
          <a class="sm-text bottom text-link blue-bg"
            ><span>Get the Resources</span
            ><span><i class="fas fa-chevron-right"></i></span>
          </a>
          <!-- <a class="blue-bg">Apply for this program </a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "programsCard",
};
</script>
